// App-Konfiguration für das gemeinsame UI-Kit (Master: design-system/kit/kit.master.js).
// NUR die bewussten Unterschiede zwischen Admin und Partner leben hier (MASTER.md):
//   bg          — Seitenhintergrund (Admin #f5f5f5, Partner #f7f7f8; Eigentümer-Vorgabe)
//   classPrefix — null: das Kit erzeugt KEINE eigenen className-Attribute (Admin heute)
//   statVariant — 'regular': ruhige, größere Kennzahl-Kachel (Admin heute)
const KIT_CONFIG = { bg: '#f5f5f5', classPrefix: null, statVariant: 'regular' };
export default KIT_CONFIG;
